import styled, { keyframes } from "styled-components";
import { fadeInDown } from "react-animations";
import { primaryColor, primaryColorHover } from "../../../../config/constants";
import Slider from "@mui/material/Slider";

// Keyframes
const fadeInDownAnimation = keyframes`${fadeInDown}`;

export const Container = styled.div`
  margin: 10px auto 20px;
  width: 100%;
  max-width: 860px;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
  border-radius: 5px;
  border-left: 8px solid ${primaryColor};
  animation: 0.4s ${fadeInDownAnimation};
  overflow-x: hidden;
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const Header = styled.div`
  padding: 10px 20px;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 2px #e6e6e6 solid;
`;
export const Title = styled.p`
  font-size: 16px;
`;
export const ControlText = styled.p`
  margin: ${({ margin }) => margin && margin};
  font-size: 14px;
  font-weight: bold;
  opacity: ${({ opacity }) => opacity && opacity};
`;

export const ControlsDiv = styled.div`
  padding: 10px 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 2px #e6e6e6 solid;
`;
export const ProtocolControlHeaderDiv = styled.div`
  margin: 20px 0 15px;
  width: 55%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const ProtocolControlDiv = styled.div`
  margin-bottom: 10px;
  width: 55%;
  display: flex;
  flex-direction: column;
`;
export const ProtocolControlAlignerDiv = styled.div`
  padding-left: ${({ paddingLeft }) => paddingLeft && paddingLeft};
  display: flex;
  align-items: center;
`;
export const RangeAlignerDiv = styled.div`
  margin-top: 5px;
  padding-left: ${({ paddingLeft }) => paddingLeft && paddingLeft};
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
export const RangeSlider = styled(Slider)({
  "& .MuiSlider-track": {
    backgroundColor: primaryColor,
    border: "none",
  },
  "& .MuiSlider-rail": {
    backgroundColor: primaryColor,
  },
  "& .MuiSlider-thumb": {
    backgroundColor: primaryColor,
  },
  "& .MuiSlider-mark": {
    backgroundColor: "#000",
    "&.MuiSlider-markActive": {
      opacity: 1,
      backgroundColor: "#FFF",
    },
  },
});
export const ActionButtonsDiv = styled.div`
  padding: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 910px) {
    flex-direction: column;
  }
`;
export const ActionButton = styled.button`
  margin: 0 10px;
  padding: 10px 20px;
  background-color: ${({ primary }) => (primary ? primaryColor : "transparent")};
  border: ${({ primary }) => (primary ? "none" : `1px solid ${primaryColor}`)};
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: ${({ primary }) => (primary ? "#fff" : primaryColor)};
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${({ primary }) => primary && primaryColorHover};
  }
  @media (max-width: 910px) {
    margin-bottom: ${({ primary }) => primary && "10px"};
    width: 180px;
  }
`;
